import axios from 'axios';
import { API_ENDPOINTS } from '../config/api';

export const nodeService = {
  createNode,
  updateNode,
  deleteNode,
  updatePermissions,
  moveNode
};

function createNode(parentId, nodeData) {
  const user = JSON.parse(localStorage.getItem('user'));
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${user.token}`
  };

  return axios.post(
    API_ENDPOINTS.NODES.CREATE,
    {
      parentId,
      ...nodeData
    },
    { headers }
  );
}

function updateNode(nodeId, nodeData) {
  const user = JSON.parse(localStorage.getItem('user'));
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${user.token}`
  };

  return axios.patch(
    API_ENDPOINTS.NODES.UPDATE(nodeId),
    nodeData,
    { headers }
  );
}

function deleteNode(nodeId) {
  const user = JSON.parse(localStorage.getItem('user'));
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${user.token}`
  };

  return axios.delete(
    API_ENDPOINTS.NODES.DELETE(nodeId),
    { headers }
  );
}

function updatePermissions(nodeId, permissions) {
  const user = JSON.parse(localStorage.getItem('user'));
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${user.token}`
  };

  // Die API erwartet action + userGroupId, nicht ein Array
  // Wir senden mehrere Requests für jede userGroup mit "view" action
  const requests = permissions.userGroupIds.map(userGroupId => 
    axios.patch(
      API_ENDPOINTS.NODES.PERMISSIONS(nodeId),
      { 
        action: 'view', // Standard-Berechtigung für Node-Ansicht
        userGroupId: userGroupId 
      },
      { headers }
    )
  );

  // Alle Requests parallel ausführen
  return Promise.all(requests);
}

function moveNode(nodeId, newParentId) {
  const user = JSON.parse(localStorage.getItem('user'));
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${user.token}`
  };

  return axios.patch(
    API_ENDPOINTS.NODES.UPDATE(nodeId),
    { parentId: newParentId },
    { headers }
  );
}
